import { SDSButton } from '@repo/sds/SDSButton';
import { SDSDialog } from '@repo/sds/SDSDialog';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSText } from '@repo/sds/SDSText';

import authenticatorCodeFailed from './assets/authenticator-code-failed.svg';
import { MfaHero } from './mfa-hero';
import { MfaSettingsPage } from './mfa-settings-page';

interface MfaInvalidCodeDialogAction {
  dataTestId: string;
  label: string;
  onClick: () => void;
}

interface MfaInvalidCodeDialogProps {
  backLabel?: string;
  dataTestId: string;
  description: string;
  isMobile?: boolean;
  onClose: () => void;
  primaryAction: MfaInvalidCodeDialogAction;
  secondaryAction: MfaInvalidCodeDialogAction;
  title: string;
}

export function MfaInvalidCodeDialog({
  backLabel,
  dataTestId,
  description,
  isMobile = false,
  onClose,
  primaryAction,
  secondaryAction,
  title,
}: MfaInvalidCodeDialogProps) {
  const body = (
    <SDSFlexbox alignItems="center" direction="column" gap="text-large">
      <MfaHero src={authenticatorCodeFailed} />
      <SDSFlexbox alignItems="center" direction="column" gap="text-medium">
        <SDSText align="center" text={title} type="h5" />
        <SDSText align="center" color="text-secondary" text={description} type="body-medium" />
      </SDSFlexbox>
    </SDSFlexbox>
  );

  if (isMobile) {
    return (
      <MfaSettingsPage ariaLabel={title} backLabel={backLabel ?? title} dataTestId={dataTestId} onBack={onClose}>
        {body}
        <SDSFlexbox direction="column" fullWidth gap="button-medium">
          <SDSButton
            dataTestId={primaryAction.dataTestId}
            isFullWidth
            onClick={primaryAction.onClick}
            text={primaryAction.label}
          />
          <SDSButton
            dataTestId={secondaryAction.dataTestId}
            isFullWidth
            mode="outline"
            onClick={secondaryAction.onClick}
            text={secondaryAction.label}
          />
        </SDSFlexbox>
      </MfaSettingsPage>
    );
  }

  return (
    <SDSDialog
      className="MfaTotpDialog"
      dataTestId={dataTestId}
      isOpen
      onClose={onClose}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      showCloseButton={false}
      size="small"
    >
      {body}
    </SDSDialog>
  );
}
